import {
  Campaign,
  TCustomerLimitType
} from '@/models/marketingCenter/freeCoins';

export type MemberLimitForm = {
  customerLimitType: TCustomerLimitType;
  customerLimit?: string;
  customerDailyLimit?: string;
  onlyNewCustomers: boolean;
};

/*
 * With the welcome coins v2 flag on the daily option is hidden, so a campaign
 * still on `daily-customer` opens as a total limit with the same number, as
 * the host's member-limit modal does. Nothing is written unless the merchant
 * confirms a change. `onlyNewCustomers` is read off the campaign either way,
 * so hiding its toggle echoes `allowRepeatingCustomers` unchanged.
 */
export const toMemberLimitForm = (
  campaign: Campaign,
  isWelcomeCoinsV2: boolean
): MemberLimitForm => {
  const { limitType, customerLimit, allowRepeatingCustomers } = campaign;
  const type =
    limitType === 'daily-customer' && isWelcomeCoinsV2
      ? 'total-customer'
      : (limitType as TCustomerLimitType);

  return {
    customerLimitType: type,
    onlyNewCustomers: !allowRepeatingCustomers,
    customerLimit:
      type === 'total-customer' ? String(customerLimit) : undefined,
    customerDailyLimit:
      type === 'daily-customer' ? String(customerLimit) : undefined
  };
};
